"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OEmbedLoader_1 = require("../../components/OEmbedLoader");
new OEmbedLoader_1.OEmbedLoader('.soundcloud-embed', 'json', 'https://soundcloud.com/oembed?format=json&url=');
